import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import NavigationAppShell from '../../common/navigation-app-shell'
import * as accountActions from '../../store/accounts'
import CountriesDropdown from '../../common/dropdowns/countries-dropdown'
import LanguagesDropdown from '../../common/dropdowns/languages-dropdown'
import Y from '../../y18n'
import Styles from '../../common/styles'

const mapStateToProps = state => ({
  accounts: state.accounts
})

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(accountActions, dispatch)
})

class ProfilePage extends Component {
  state = {
    disabled: true,
    migrationMessage: false
  }

  componentDidMount () {
    var migrationMessage = this.props.location.search === '?auth=true'
    this.setState({ migrationMessage: migrationMessage })

    if (this.props.accounts.profile.userId) {
      this.props.accountActions.getDetailedProfile(this.props.accounts.profile.userId)
    }
  }

  handleChange = name => event => {
    this.props.accountActions.updateDetailedProfile(name, event.target.value)
    this.setState({ disabled: false })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.accountActions.saveDetailedProfile(this.props.accounts.detailedProfile)
    this.setState({ disabled: true })
  }

  render () {
    const { classes, accounts } = this.props
    if (!accounts.detailedProfile) return null
    return (
      <NavigationAppShell
        content={
          <Paper elevation={3} square>
            {accounts.loading && <LinearProgress />}
            <div className={classes.content}>
              <div className={classes.textRow}>
                <Typography variant='title'>
                  {Y`My account`}
                </Typography>
                {this.state.migrationMessage
                  ? <Typography variant='body2' className={classes.spacer}>
                    {Y`Please make sure that your personal information looks correct. If something is wrong or empty, please fill it out`}
                  </Typography>
                  : <Typography variant='body2' title={Y`Please keep your personal information up to date`}>
                    {Y`Please keep your personal information up to date`}
                  </Typography>}
              </div>
              <form onSubmit={e => this.handleSubmit(e)}>
                <div className={classes.flexRow}>
                  <TextField
                    className={classes.flexItemLeft}
                    label={Y`First name`}
                    id='firstName'
                    value={accounts.detailedProfile.firstName || ''}
                    onChange={this.handleChange('firstName')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel,
                      error: accounts.detailedProfile.firstName === null
                    }}
                    required
                  />
                  <TextField
                    className={classes.flexItemRight}
                    label={Y`Last name`}
                    id='lastName'
                    value={accounts.detailedProfile.lastName || ''}
                    onChange={this.handleChange('lastName')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel,
                      error: accounts.detailedProfile.lastName === null
                    }}
                    required
                  />
                </div>
                <div className={classes.flexRow}>
                  <TextField
                    className={classes.spacer}
                    label={Y`Email`}
                    id='email'
                    value={accounts.detailedProfile.email || ''}
                    onChange={this.handleChange('email')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel,
                      error: accounts.detailedProfile.email === null
                    }}
                    fullWidth
                    required
                  />
                </div>
                <div className={classes.flexRow}>
                  <TextField
                    className={classes.spacer}
                    label={Y`Phone number`}
                    id='phoneNumber'
                    value={accounts.detailedProfile.phoneNumber || ''}
                    onChange={this.handleChange('phoneNumber')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel,
                      error: accounts.detailedProfile.phoneNumber === null
                    }}
                    fullWidth
                    required
                  />
                </div>
                <div className={classes.flexRow}>
                  <TextField
                    className={classes.spacer}
                    label={Y`Address`}
                    id='address'
                    value={accounts.detailedProfile.address || ''}
                    onChange={this.handleChange('address')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel,
                      error: accounts.detailedProfile.address === null
                    }}
                    required
                    fullWidth
                  />
                </div>
                <div className={classes.flexRow}>
                  <TextField
                    className={classes.flexItemLeft}
                    label={Y`Zip code`}
                    id='zipCode'
                    value={accounts.detailedProfile.zipCode || ''}
                    onChange={this.handleChange('zipCode')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel,
                      error: accounts.detailedProfile.zipCode === null
                    }}
                    required
                  />
                  <TextField
                    className={classes.flexItemRight}
                    label={Y`City`}
                    id='city'
                    value={accounts.detailedProfile.city || ''}
                    onChange={this.handleChange('city')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel,
                      error: accounts.detailedProfile.city === null
                    }}
                    required
                  />
                </div>
                <div className={classes.flexRow}>
                  <div className={classes.flexItemLeft}>
                    <CountriesDropdown
                      handleChange={this.handleChange('country')}
                      value={accounts.detailedProfile.country || 'Sweden'}
                    />
                  </div>
                  <div className={classes.flexItemRight}>
                    <LanguagesDropdown
                      handleChange={this.handleChange('language')}
                      value={accounts.detailedProfile.language || 'sv'}
                    />
                  </div>
                </div>
                <div className={classes.buttonRow}>
                  <Button
                    variant='raised'
                    color='primary'
                    disabled={this.state.disabled}
                    title={this.state.disabled ? Y`No unsaved changes` : Y`Save changes`}
                    style={{ color: '#fff' }}
                    type='submit'
                  >{Y`Save changes`}</Button>
                </div>
              </form>
            </div>
          </Paper>
        }
        pageName={'Profile'}
      />
    )
  }
}

ProfilePage = connect(mapStateToProps, mapDispatchToProps)(ProfilePage)
export default withStyles(Styles)(ProfilePage)



// WEBPACK FOOTER //
// ./src/pages/account/profile.js